import createRouteUrlProvider from 'utils/routeUrlProvider';

export const HOME = 'HOME';
export const HOTEL = 'HOTEL';
export const PAYMENTS = 'PAYMENTS';
export const AMOUNT_LESS_PAYMENT = 'AMOUNT_LESS_PAYMENT';
export const QR_PAYMENT = 'QR_PAYMENT';
export const CREDIT_CARD = 'CREDIT_CARD';
export const DIGITAL_WALLET = 'DIGITAL_WALLET';
export const RESULT = 'RESULT';
export const QR_RESULT = 'QR_RESULT';
export const RECEIPT_WITH_TOKEN = 'RECEIPT_WITH_TOKEN';
export const RECEIPT = 'RECEIPT';
export const SEND_QR_RECEIPT = 'SEND_QR_RECEIPT';
export const CAPTURE_LATER_RESULT = 'CAPTURE_LATER_RESULT';
export const NOTFOUND = 'NOTFOUND';
export const ORACLE_PAYMENT = 'ORACLE_PAYMENT';
export const THIRD_PAYMENT_PENDING = 'THIRD_PAYMENT_PENDING';
export const ORACLE_PAYMENT_DETAIL = 'ORACLE_PAYMENT_DETAIL';
export const THIRD_PARTY_PAYMENT = 'THIRD_PARTY_PAYMENT';
export const ERROR_HAS_BEEN_PAID = 'ERROR_HAS_BEEN_PAID';
export const SPLIT_PAYMENTS = 'SPLIT_PAYMENTS';
export const SPLIT_WAITING = 'SPLIT_WAITING';
export const SPLIT_BILL_PRE_ITEM = 'SPLIT_BILL_PRE_ITEM';
export const SPLIT_BILL_BY_ITEM = 'SPLIT_BILL_BY_ITEM';
export const SPLIT_BILL_EQUALITY = 'SPLIT_BILL_EQUALITY';
export const ERROR_FULL_ACCESS = 'ERROR_FULL_ACCESS';
export const VERIFY_YOUR_PAYMENT = 'VERIFY_YOUR_PAYMENT';
export const LINK_EXPIRED = 'LINK_EXPIRED';
export const PAYMENT_STATUS = 'PAYMENT_STATUS';
export const SOMETHING_WRONG = 'SOMETHING_WRONG';
export const SHOP = 'SHOP';
export const SHOP_SUCCESS = 'SHOP_SUCCESS';
export const WIDGET_DESIGNER = 'WIDGET_DESIGNER';

const routeUrlProvider = createRouteUrlProvider();

routeUrlProvider.set(HOME, '/');
// Must stay ahead of PAYMENTS ('/:token') when registered in the router.
routeUrlProvider.set(SHOP, '/shop/:shopCode');
routeUrlProvider.set(SHOP_SUCCESS, '/shop/:shopCode/success');
routeUrlProvider.set(WIDGET_DESIGNER, '/widget');
routeUrlProvider.set(HOTEL, '/hotel');
routeUrlProvider.set(PAYMENTS, '/:token');
routeUrlProvider.set(AMOUNT_LESS_PAYMENT, '/amount-less/:token');
routeUrlProvider.set(CREDIT_CARD, '/:token/creditcard');
routeUrlProvider.set(DIGITAL_WALLET, '/:token/digitalwallet');
routeUrlProvider.set(RESULT, '/result');
routeUrlProvider.set(QR_PAYMENT, '/qr');
routeUrlProvider.set(QR_RESULT, '/result/qr');
routeUrlProvider.set(RECEIPT, '/result/receipt');
routeUrlProvider.set(RECEIPT_WITH_TOKEN, '/result/receipt/:token');
routeUrlProvider.set(SEND_QR_RECEIPT, '/result/sendreceipt');
routeUrlProvider.set(CAPTURE_LATER_RESULT, '/result/capture');
routeUrlProvider.set(ORACLE_PAYMENT, '/qr-oracle/:token');
routeUrlProvider.set(ORACLE_PAYMENT_DETAIL, '/qr-oracle/detail');
routeUrlProvider.set(THIRD_PARTY_PAYMENT, '/third-party/:token');
routeUrlProvider.set(THIRD_PAYMENT_PENDING, '/third-payment-pending/:token');
routeUrlProvider.set(ERROR_HAS_BEEN_PAID, '/404/payment-has-been-paid');
routeUrlProvider.set(NOTFOUND, '/404');
routeUrlProvider.set(SPLIT_PAYMENTS, 'split-bill/:token');
routeUrlProvider.set(SPLIT_WAITING, '/split-bill-waiting');
routeUrlProvider.set(SPLIT_BILL_PRE_ITEM, '/:token/split-bill-pre-item');
routeUrlProvider.set(SPLIT_BILL_BY_ITEM, '/:token/split-bill-by-item');
routeUrlProvider.set(SPLIT_BILL_EQUALITY, '/:token/split-bill-equality');
routeUrlProvider.set(ERROR_FULL_ACCESS, '/404/full-access');
routeUrlProvider.set(VERIFY_YOUR_PAYMENT, '/verify-your-payment');
routeUrlProvider.set(LINK_EXPIRED, '/404/link-expired');
routeUrlProvider.set(PAYMENT_STATUS, '/payment-status/:token');
routeUrlProvider.set(SOMETHING_WRONG, '/500/something-wrong');

export default routeUrlProvider;
